import { ArrowDownDark } from '@icons';
import { UseMutationResult } from '@tanstack/react-query';
import React, { Dispatch, useEffect, useRef } from 'react';
import { Button, Form } from 'react-bootstrap';

export type UploadChoiceType = 'FULL' | 'PARTIAL' | 'PARTIAL_DELTA';

interface UploadDataButtonProps {
	itemToUpload: {
		key: string;
		label: string;
		description: string;
		mutation: UseMutationResult<any, Error, { file: File; uploadType?: UploadChoiceType }, unknown>;
		accepts?: string;
	};
	setSelectedFile?: Dispatch<React.SetStateAction<File | undefined>>;
}

const UploadDataButton: React.FC<UploadDataButtonProps> = ({ itemToUpload, setSelectedFile }) => {
	const fileInputRef = useRef<HTMLInputElement | null>(null);
	const handleOnClick = () => {
		fileInputRef.current?.click();
	};
	const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		const file = event.target.files?.[0];
		if (file) {
			setSelectedFile(file);
		}
	};

	useEffect(() => {
		if (itemToUpload.mutation.isSuccess || itemToUpload.mutation.isError) {
			if (fileInputRef.current) {
				fileInputRef.current.value = '';
			}
			setSelectedFile(undefined);
		}
		const fileInputCurrent = fileInputRef.current;
		return () => {
			if (fileInputCurrent) {
				fileInputCurrent.value = '';
			}
		};
	}, [itemToUpload.mutation.isSuccess, itemToUpload.mutation.isError, setSelectedFile]);

	return (
		<>
			<Button
				onClick={handleOnClick}
				className="btn custom-primary-button"
				style={{
					height: '48px',
					fontWeight: 500,
					padding: '12px 24px',
					display: 'flex',
					alignItems: 'center',
					justifyContent: 'center',
					gap: '0.5rem',
					minWidth: '185px',
				}}
			>
				<ArrowDownDark
					style={{
						rotate: '180deg',
					}}
				/>
				Carica file
			</Button>
			<Form.Control
				type="file"
				{...(itemToUpload.accepts ? { accept: itemToUpload.accepts } : {})}
				ref={fileInputRef}
				onChange={handleFileChange}
				style={{ display: 'none' }}
			/>
		</>
	);
};

export default UploadDataButton;
